import styled from "@emotion/styled";

export const LogoContailer = styled.a`
  width: 48px;
  height: 48px;
  border-radius: 4px;
  border: 0.5px solid #3b3b3b;
  background: linear-gradient(180deg, #282828 0%, #1a1c1e 100%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding-left: 2px;
  padding-top: 2px;
  margin-bottom: 40px;
  @media (max-width: 768px) {
    margin-bottom: 0px;
    margin-left: 20px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  margin: auto;
  display: flex;
  flex-direction: row;
  @media (max-width: 1030px) {
  }
`;

export const Humburger = styled.div`
  width: 32px;
  height: 32px;
  cursor: pointer;
  @media (min-width: 769px) {
    display: none;
  }
`;

export const Header = styled.header`
  width: 100px;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.primary};
  @media (max-width: 768px) {
    width: 100%;
    height: 70px;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
  }
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  overflow: auto;
  padding: 70px 24px;
  @media (max-width: 1030px) {
  }
`;

export const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 0px;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1000;
  border-right: 1px solid ${({ theme }) => theme.colors.border.seconday};
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-right: none;
  }
`;

export const DropDowneButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
